module.exports = __webpack_public_path__ + "static/media/google-play-btn@2.b08a2b9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/google-play-btn@2.png
// module id = 1562
// module chunks = 103